export enum ROUTES_NAMES {
  AVERTISSEMENTS = 'avertissement',
  REJOINDRE_DOSSIER = 'rejoindre-dossier',
  CONFIRMATION = 'confirmation'
}

export enum BREAD_STEPS {
  AVERTISSEMENTS= 'Avertissement',
  REJOINDRE_DOSSIER= 'Saisie du code',
  // PAGE_TITLE_SUFFIX unusable in enum
  CONFIRMATION= 'Confirmation de rattachement'
}

export enum PAGES_TITLES {
  AVERTISSEMENTS= 'Avertissement (Étape 1) | Rattacher un dossier à mon compte | Télérecours citoyens | Conseil d\'État',
  REJOINDRE_DOSSIER= 'Saisie du code (Étape 2) | Rattacher un dossier à mon compte | Télérecours citoyens | Conseil d\'État',
  CONFIRMATION= 'Confirmation de rattachement (Étape 3) | Rattacher un dossier à mon compte | Télérecours citoyens | Conseil d\'État'
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/rattachement/rattachement.model.ts